import { inject, Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmOptions } from './confirm.types';

const DEFAULT_MODAL_OPTIONS: NgbModalOptions = {
    centered: true,
    backdrop: 'static',
    keyboard: false,
    size: 'sm',
    windowClass: 'confirm-dialog-modal',
};

@Injectable({ providedIn: 'root' })
export class ConfirmService {
    private readonly modal = inject(NgbModal);

    ask<T = unknown>(options: ConfirmOptions, modalOptions?: NgbModalOptions): Promise<T> {
        const ref = this.modal.open(ConfirmDialogComponent, {
            ...DEFAULT_MODAL_OPTIONS,
            ...modalOptions,
        });
        Object.assign(ref.componentInstance, options);
        return ref.result as Promise<T>;
    }
}
